package core.extensions

fun String.toMinimizedString(): String {
    return this.replace(" ", "").lowercase()
}